export const TOGGLE_BOTTOM_BAR = "TOGGLE_BOTTOM_BAR";